<template>
    <div v-if="currentLinks && currentLinks.length > 0">
        <div :id="link.key" v-for="link in currentLinks" :key="link" class="shadow-2 m-2 p-2">

            <!-- For the topmost parent, this will not be shown -->
            <div v-if="!props.parent && currentLinks.length > 1" class="flex justify-content-end h-2rem">
                <span class="text-lg px-2 close-button" @click="confirm($event, link.key)">&#10006;</span>
            </div>
            <div v-if="link.type === 'connector'" class="grid flex-wrap-reverse">
                <!-- If connector type then show it with a divider -->
                <div class="col-12 md:col-8">
                    <logic-selection v-model="link.logical_operation" :linkKey="link.key" :displayFlag="link.display" />
                </div>
                <!-- Logic Selection ends -->
                <!-- In Logical Operation NOT, there can be only one procedure so we will hide it once it has one Child -->
                <div class="col-12 md:col-4 justify-content-end">
                    <link-type-selector v-if="!hideInnerLinkSelection(link)" :linkKey="link.key" :parent="props.parent" />
                </div>
                <!-- Buttons for inner links ends-->
            </div>
            <div v-else class="col-12">
                <procedure-value v-if="link.type === 'procedure'" :link="link" />
                <!-- Procedure Selection ends -->
                <div v-else-if="link.type === 'attribute'">Attribute Type</div>
                <!-- Procedure Selection ends -->
            </div>
            <!-- Add buttons for inner links ends -->
            <div class="ml-3" :key="link.key">
                <data-source-pro-links v-if="link.links && link.links.length > 0 && link.display" :currentLinks="link.links" />
            </div>
        </div>
    </div>
</template>

<script setup>
import LogicSelection from '../components/LogicSelection.vue';
import LinkTypeSelector from '../components/LinkTypeSelector.vue';
import ProcedureValue from '../components/procedures/ProcedureValue.vue';
import DataSourceProLinks from './DataSourceProLinks.vue';

import { defineProps, onBeforeUnmount } from 'vue';
import { useDataSourceStore } from '../store';
import { useConfirmComposable } from '../../../../../composables/ConfirmComposable';

const dataSourceStore = useDataSourceStore();
const { confirmPopRequest } = useConfirmComposable();

const props = defineProps({
    currentLinks: {
        type: Array,
    },
    parent: {
        type: Boolean,
        default: false,
    },
});

const hideInnerLinkSelection = (link) => {
    return link.logical_operation === 'NOT' && link.links && link.links.length === 1;
};

const confirm = (event, key) => {
    confirmPopRequest(event, key, dataSourceStore.removeLinkWithKey);
};

// Before unmounting the component, make sure to delete the store data for datasource
onBeforeUnmount(() => {
    dataSourceStore.initDataSource();
});
</script>

<style>
.close-button:hover {
    cursor: pointer;
    border: 1px dashed black;
    padding: 0;
    margin: 0;
}
</style>
